import React, {useState, useEffect} from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import { Form, Button, Row, Col, } from 'react-bootstrap';

import {Axios} from 'helpers/axios';
import HabilitationService from 'services/habilitationsService';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { formMonCompteClient } from 'helpers/yupValidationSchema';

const UserInfo = () => {
	const [isLoading, setLoading] = useState(false);
    const [readyToDisplay, setReadyToDisplay] = useState(false);

	const { register, handleSubmit, formState: { errors }, setValue, } = useForm({
        resolver: yupResolver(formMonCompteClient),
    });

    const initValue = async () => {
        try {
            const response = await Axios.get('/authenticatedRoutes/settingsCompte/getOneUser');
            
            setValue("nomClient", response.data.nomClient);
            setValue("prenomClient", response.data.prenomClient);
            setValue("mailClient", response.data.mailClient);
            setValue("telClient", response.data.telClient);

            setReadyToDisplay(true);
        } catch (error) {
            console.error(error)
        }
    }

	const save = async (data) => {
		try {
            setLoading(true);
			await Axios.post('/authenticatedRoutes/settingsCompte/updateMonCompte',{
                ...data
            });

			HabilitationService.disconnect();
			location.reload();
		} catch (e) {
			console.error(e);
		}
	}

    useEffect(() => {
        initValue();
    }, [])

	return (
		<>
		<FalconComponentCard>
			<FalconComponentCard.Header
				title="Modifier mes informations"
			>
			</FalconComponentCard.Header>
			<FalconComponentCard.Body>
                {readyToDisplay ? (
                    <Form onSubmit={handleSubmit(save)} autoComplete="off">
						<Row>
							<Col md={6}>
								<Form.Group className="mb-3">
									<Form.Label>Nom</Form.Label>
									<Form.Control type="text" name="nomClient" id="nomClient" {...register("nomClient")} isInvalid={!!errors.nomClient}/>
									<small className="text-danger">{errors.nomClient?.message}</small>
								</Form.Group>
							</Col>
							<Col md={6}>
								<Form.Group className="mb-3">
									<Form.Label>Prénom</Form.Label>
									<Form.Control type="text" name="prenomClient" id="prenomClient" {...register("prenomClient")} isInvalid={!!errors.prenomClient}/>
									<small className="text-danger">{errors.prenomClient?.message}</small>
								</Form.Group>
							</Col>
							<Col md={6}>
								<Form.Group className="mb-3">
									<Form.Label>Mail <small>(Identifiant de connexion)</small></Form.Label>
									<Form.Control type="email" name="mailClient" id="mailClient" {...register("mailClient")} disabled/>
									<small className="text-danger">{errors.mailClient?.message}</small>
								</Form.Group>
							</Col>
							<Col md={6}>
								<Form.Group className="mb-3">
									<Form.Label>Téléphone</Form.Label>
									<Form.Control type="text" name="telClient" id="telClient" {...register("telClient")} isInvalid={!!errors.telClient}/>
									<small className="text-danger">{errors.telClient?.message}</small>
								</Form.Group>
							</Col>
						</Row>

                        <Button variant='primary' className='me-2 mb-1' type="submit" disabled={isLoading}>{isLoading ? 'Patientez...' : 'Enregistrer'}</Button>
                    </Form>
                ) : "Chargement en cours"}
			</FalconComponentCard.Body>
		</FalconComponentCard>
		</>
	);
};

UserInfo.propTypes = {};

export default UserInfo;